import React, { useState } from 'react';
import { Phone, MapPin, Instagram, Facebook } from 'lucide-react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<null | 'privacy' | 'terms'>(null);
  return <footer className="bg-black border-t border-gold/20 pt-16 pb-8" data-id="element-160">
      <div className="container mx-auto px-4 md:px-6" data-id="element-161">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-162">
          {/* Logo & About */}
          <div className="space-y-6" data-id="element-163">
            <img src="https://cdn.magicpatterns.com/uploads/6U8Zqe8m1fPZcxDL2DDpsS/logorendcelebrate.png" alt="Celebrate Your Party Logo" className="h-36 md:h-40 w-auto -my-4" style={{
            WebkitMaskImage: 'radial-gradient(circle at center, black 50%, transparent 54%)',
            maskImage: 'radial-gradient(circle at center, black 50%, transparent 54%)'
          }} data-id="element-164" />
            <p className="text-cream/70 font-light text-sm max-w-xs" data-id="element-165">
              Cada evento cuenta una historia. Nosotros estamos aquí para
              capturarla. Lujo, elegancia y recuerdos eternos para la comunidad
              hispana.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-166">
            <h4 className="text-gold font-serif font-semibold text-lg mb-6" data-id="element-167">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-3" data-id="element-168">
              <li data-id="element-169">
                <a href="#inicio" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-170">
                  Inicio
                </a>
              </li>
              <li data-id="element-171">
                <a href="#servicio" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-172">
                  El Servicio
                </a>
              </li>
              <li data-id="element-173">
                <a href="#testimonios" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-174">
                  Testimonios
                </a>
              </li>
              <li data-id="element-175">
                <a href="#preguntas" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-176">
                  Preguntas Frecuentes
                </a>
              </li>
              <li data-id="element-177">
                <a href="#reservar" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-178">
                  Reservar Fecha
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-179">
            <h4 className="text-gold font-serif font-semibold text-lg mb-6" data-id="element-180">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-181">
              <li data-id="element-182">
                <a href="tel:+14049409785" className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-183">
                  <Phone className="w-4 h-4" data-id="element-184" />
                  <span data-id="element-185">(404) 940-9785</span>
                </a>
              </li>
              <li data-id="element-186">
                <a href="tel:+16784721588" className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-187">
                  <Phone className="w-4 h-4" data-id="element-188" />
                  <span data-id="element-189">(678) 472-1588</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-cream/70 text-sm" data-id="element-190">
                <MapPin className="w-4 h-4 shrink-0 mt-0.5" data-id="element-191" />
                <span data-id="element-192">Atlanta, GA y área metropolitana</span>
              </li>
              <li data-id="element-193">
                <a href="https://instagram.com/celebrateyp" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gold hover:text-gold-light transition-colors text-sm font-medium" data-id="element-194">
                  <Instagram className="w-4 h-4" data-id="element-195" />
                  <span data-id="element-196">@celebrateyp</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-197">
          <p className="text-cream/50 text-xs text-center md:text-left" data-id="element-198">
            © {new Date().getFullYear()} Celebrate Events · Atlanta, GA. Todos
            los derechos reservados.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs" data-id="element-199">
            <button onClick={() => setOpenModal('privacy')} className="text-cream/60 hover:text-gold transition-colors" data-id="element-200">
              Política de Privacidad
            </button>
            <span className="text-cream/20" data-id="element-201">·</span>
            <button onClick={() => setOpenModal('terms')} className="text-cream/60 hover:text-gold transition-colors" data-id="element-202">
              Términos y Condiciones
            </button>
          </div>

          <div className="flex items-center gap-4" data-id="element-203">
            <a href="https://instagram.com/celebrateyp" target="_blank" rel="noopener noreferrer" aria-label="Instagram @celebrateyp" className="text-gold hover:text-gold-light transition-colors hover:drop-shadow-[0_0_8px_rgba(212,175,55,0.6)]" data-id="element-204">
              <Instagram className="w-5 h-5" data-id="element-205" />
            </a>
            <a href="#" aria-label="Facebook" className="text-cream/50 hover:text-gold transition-colors" data-id="element-206">
              <Facebook className="w-5 h-5" data-id="element-207" />
            </a>
          </div>
        </div>
      </div>

      {/* Privacy Modal */}
      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-208">
        <p className="text-xs text-cream/50 uppercase tracking-wide" data-id="element-209">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p data-id="element-210">
          En <strong data-id="element-211">Celebrate Events</strong> valoramos profundamente tu
          privacidad y la confianza que depositas en nosotros al compartir tus
          datos personales. Esta política describe cómo recopilamos, usamos y
          protegemos tu información.
        </p>

        <h3 data-id="element-212">1. Información que recopilamos</h3>
        <p data-id="element-213">
          Cuando contactas con nosotros o reservas un evento, podemos solicitar:
        </p>
        <ul data-id="element-214">
          <li data-id="element-215">
            Nombre completo y datos de contacto (teléfono, correo electrónico).
          </li>
          <li data-id="element-216">
            Información del evento (fecha, ubicación, tipo de celebración).
          </li>
          <li data-id="element-217">
            Fotografías y contenido tomado durante el evento con nuestro Mirror
            Photo Booth.
          </li>
          <li data-id="element-218">Mensajes y comunicaciones que intercambies con nosotros.</li>
        </ul>

        <h3 data-id="element-219">2. Cómo usamos tu información</h3>
        <ul data-id="element-220">
          <li data-id="element-221">Para confirmar y coordinar la reserva de tu evento.</li>
          <li data-id="element-222">
            Para brindarte atención personalizada antes, durante y después del
            servicio.
          </li>
          <li data-id="element-223">
            Para enviarte una galería digital de las fotos tomadas en tu evento.
          </li>
          <li data-id="element-224">
            Para mejorar nuestros servicios y comunicarnos contigo sobre
            promociones (solo si lo autorizas).
          </li>
        </ul>

        <h3 data-id="element-225">3. Compartir información con terceros</h3>
        <p data-id="element-226">
          <strong data-id="element-227">Nunca vendemos ni alquilamos tus datos personales.</strong>{' '}
          Solo compartimos información cuando es estrictamente necesario para
          prestar el servicio (por ejemplo, con proveedores de impresión o
          almacenamiento de galerías), bajo estrictas obligaciones de
          confidencialidad.
        </p>

        <h3 data-id="element-228">4. Uso de fotografías</h3>
        <p data-id="element-229">
          Las fotografías tomadas en tu evento son tuyas y de tus invitados.
          Podríamos solicitar tu autorización por escrito para usar algunas de
          ellas en nuestro portafolio o redes sociales. Si no deseas que las
          usemos, simplemente avísanos y respetaremos tu decisión.
        </p>

        <h3 data-id="element-230">5. Seguridad de los datos</h3>
        <p data-id="element-231">
          Implementamos medidas técnicas y organizativas razonables para
          proteger tu información contra acceso no autorizado, pérdida o
          alteración.
        </p>

        <h3 data-id="element-232">6. Tus derechos</h3>
        <p data-id="element-233">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. Para ejercer estos derechos, contáctanos al{' '}
          <a href="tel:+14049409785" data-id="element-234">(404) 940-9785</a>.
        </p>

        <h3 data-id="element-235">7. Cambios a esta política</h3>
        <p data-id="element-236">
          Podemos actualizar esta política ocasionalmente. La fecha de última
          actualización aparece al inicio del documento.
        </p>

        <h3 data-id="element-237">8. Contacto</h3>
        <p data-id="element-238">
          Si tienes preguntas sobre cómo manejamos tu información, escríbenos o
          llámanos. Estamos para servirte — en tu idioma, con respeto y
          transparencia.
        </p>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-239">
        <p className="text-xs text-cream/50 uppercase tracking-wide" data-id="element-240">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p data-id="element-241">
          Al contratar los servicios de <strong data-id="element-242">Celebrate Events</strong>,
          aceptas los siguientes términos y condiciones. Por favor léelos con
          atención.
        </p>

        <h3 data-id="element-243">1. Servicios</h3>
        <p data-id="element-244">
          Celebrate Events ofrece el alquiler del Mirror Photo Booth y servicios
          relacionados (instalación, atendente, impresión, diseño personalizado,
          fondo decorativo y galería digital) para eventos sociales y
          corporativos en el área metropolitana de Atlanta, GA.
        </p>

        <h3 data-id="element-245">2. Reserva de fecha</h3>
        <ul data-id="element-246">
          <li data-id="element-247">
            La fecha del evento se considera reservada únicamente al recibir el
            depósito acordado.
          </li>
          <li data-id="element-248">
            Recomendamos reservar con un mínimo de 4 a 8 semanas de
            anticipación.
          </li>
          <li data-id="element-249">
            Las fechas en temporada alta (mayo, junio, octubre y diciembre) se
            agotan rápido y se reservan por orden de llegada.
          </li>
        </ul>

        <h3 data-id="element-250">3. Pagos</h3>
        <ul data-id="element-251">
          <li data-id="element-252">
            Se requiere un depósito para asegurar la fecha. El monto se acuerda
            al firmar el contrato.
          </li>
          <li data-id="element-253">
            El saldo restante debe pagarse antes del inicio del evento, salvo
            acuerdo distinto.
          </li>
          <li data-id="element-254">Aceptamos efectivo, transferencia electrónica y Zelle.</li>
        </ul>

        <h3 data-id="element-255">4. Cancelaciones y reprogramaciones</h3>
        <ul data-id="element-256">
          <li data-id="element-257">
            Las cancelaciones realizadas con más de 30 días de anticipación
            pueden recibir reembolso parcial del depósito, sujeto a evaluación.
          </li>
          <li data-id="element-258">
            Las cancelaciones con menos de 30 días pierden el depósito por
            costos administrativos y de reserva.
          </li>
          <li data-id="element-259">
            Las reprogramaciones están sujetas a disponibilidad y se gestionan
            sin costo adicional cuando se solicitan con anticipación razonable.
          </li>
        </ul>

        <h3 data-id="element-260">5. Responsabilidades del cliente</h3>
        <ul data-id="element-261">
          <li data-id="element-262">
            Proveer un espacio adecuado para el espejo (mínimo recomendado: 3m x
            3m) con acceso a toma de corriente eléctrica.
          </li>
          <li data-id="element-263">
            Garantizar el trato respetuoso de nuestro equipo y atendente durante
            el evento.
          </li>
          <li data-id="element-264">
            Cubrir el costo de reparación o reposición en caso de daño causado
            por invitados al equipo.
          </li>
        </ul>

        <h3 data-id="element-265">6. Responsabilidades de Celebrate Events</h3>
        <ul data-id="element-266">
          <li data-id="element-267">
            Llegar a tiempo e instalar el equipo antes del inicio del evento.
          </li>
          <li data-id="element-268">
            Operar el espejo y asistir a los invitados durante toda la duración
            contratada.
          </li>
          <li data-id="element-269">
            Entregar fotos impresas de calidad profesional al instante,
            personalizadas con el nombre y fecha del evento.
          </li>
          <li data-id="element-270">
            Compartir la galería digital con el cliente dentro de los días
            posteriores al evento.
          </li>
        </ul>

        <h3 data-id="element-271">7. Limitación de responsabilidad</h3>
        <p data-id="element-272">
          Celebrate Events no se hace responsable por interrupciones causadas
          por fallas en el suministro eléctrico del lugar, condiciones
          climáticas extremas (en eventos al aire libre sin protección adecuada)
          o circunstancias fuera de nuestro control. En tales casos trabajaremos
          con el cliente para minimizar el impacto.
        </p>

        <h3 data-id="element-273">8. Uso de las fotografías</h3>
        <p data-id="element-274">
          Las fotos tomadas durante el evento pertenecen al cliente y sus
          invitados. Celebrate Events puede solicitar autorización para mostrar
          algunas en su portafolio o redes sociales. El cliente puede rechazar
          este uso sin penalización.
        </p>

        <h3 data-id="element-275">9. Modificaciones</h3>
        <p data-id="element-276">
          Estos términos pueden actualizarse en cualquier momento. La versión
          aplicable a tu evento será la vigente a la fecha de tu contrato.
        </p>

        <h3 data-id="element-277">10. Jurisdicción</h3>
        <p data-id="element-278">
          Cualquier controversia se resolverá conforme a las leyes del estado de
          Georgia, EE. UU.
        </p>

        <h3 data-id="element-279">11. Contacto</h3>
        <p data-id="element-280">
          Para cualquier duda relacionada con estos términos, comunícate al{' '}
          <a href="tel:+14049409785" data-id="element-281">(404) 940-9785</a> o{' '}
          <a href="tel:+16784721588" data-id="element-282">(678) 472-1588</a>.
        </p>
      </LegalModal>
    </footer>;
}